/* Venom PC Builder — no subjective assessment on exported media (staging). */
(function () {
  'use strict';
  if (window.__venomNoRatingsExportsV1) return;
  window.__venomNoRatingsExportsV1 = true;

  function isBuilderExport(canvas) {
    return canvas && canvas.width === 1080 && canvas.height === 1350 &&
      !!document.querySelector('[id^="vpb-pro-"].vpb-pro-host, [id^="vpb-pro-"] .sum-actions');
  }

  function hasCustomerName() {
    var config = document.querySelector('script[type="application/json"][id^="vpb-pro-data-"]');
    if (!config) return false;
    try {
      var parsed = JSON.parse(config.textContent || '{}');
      return !!String((parsed.settings && parsed.settings.customerName) || '').trim();
    } catch (err) {
      console.warn('Venom export: missing customer config', err);
      return false;
    }
  }

  // Both PNG export and PDF export serialize this same canvas.
  // Cut the 5 subjective score badges, then move components up into the space.
  function withoutRatingBand(source) {
    var W = source.width, H = source.height;
    var scoreY = (hasCustomerName() ? 226 : 148) + 132;
    var scoreHeight = 102;
    var footerY = 1248;
    var out = document.createElement('canvas');
    out.width = W;
    out.height = H;
    var ctx = out.getContext('2d');
    if (!ctx) return source;

    var bg = ctx.createLinearGradient(0, 0, W, H);
    bg.addColorStop(0, '#070708');
    bg.addColorStop(0.55, '#101014');
    bg.addColorStop(1, '#08080a');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = '#ed1c24';
    ctx.fillRect(0, 0, 10, H);

    // Header and total (unaltered).
    ctx.drawImage(source, 0, 0, W, scoreY, 0, 0, W, scoreY);
    // Component table, with assessment strip removed.
    var contentHeight = footerY - scoreY - scoreHeight;
    ctx.drawImage(source, 0, scoreY + scoreHeight, W, contentHeight,
      0, scoreY, W, contentHeight);
    // Keep existing footer, but leave out its old performance-rating disclaimer.
    ctx.drawImage(source, 0, footerY, W, 68, 0, footerY, W, 68);
    ctx.save();
    ctx.font = '500 10px Inter, Arial, sans-serif';
    ctx.fillStyle = '#656771';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    ctx.fillText('Builder prices shown at export time.', 64, 1334);
    ctx.restore();
    return out;
  }

  var nativeToBlob = HTMLCanvasElement.prototype.toBlob;
  if (typeof nativeToBlob === 'function') {
    HTMLCanvasElement.prototype.toBlob = function (callback, type, quality) {
      if (isBuilderExport(this)) {
        try {
          return nativeToBlob.call(withoutRatingBand(this), callback, type, quality);
        } catch (err) {
          console.error('Venom assessment-free export failed', err);
          if (typeof callback === 'function') callback(null);
          return;
        }
      }
      return nativeToBlob.call(this, callback, type, quality);
    };
  }

  var nativeToDataURL = HTMLCanvasElement.prototype.toDataURL;
  if (typeof nativeToDataURL === 'function') {
    HTMLCanvasElement.prototype.toDataURL = function () {
      if (isBuilderExport(this)) {
        try {
          return nativeToDataURL.apply(withoutRatingBand(this), arguments);
        } catch (err) {
          console.error('Venom assessment-free data URL failed', err);
          throw err;
        }
      }
      return nativeToDataURL.apply(this, arguments);
    };
  }

  // Grayscale printing generates its own HTML inside a temporary iframe.
  // Remove its rating group before the iframe's delayed print() call.
  function cleanGrayscaleFrame(frame) {
    if (!frame || frame.id !== 'venom-grayscale-print-frame') return;
    try {
      var doc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
      if (!doc || !doc.body) return;
      doc.querySelectorAll('.scores, .review-rating-grid, .build-rating').forEach(function (node) {
        node.remove();
      });
      var note = doc.querySelector('.foot .note');
      if (note && /rating|performance|تقييم/i.test(note.textContent || '')) {
        note.textContent = 'Builder prices shown at print time.';
      }
    } catch (err) {
      console.warn('Venom grayscale print cleanup failed', err);
    }
  }

  function findAndCleanPrintFrame() {
    var frame = document.getElementById('venom-grayscale-print-frame');
    if (!frame) return;
    cleanGrayscaleFrame(frame);
    if (!frame.__venomRatingsCleanupBound) {
      frame.__venomRatingsCleanupBound = true;
      frame.addEventListener('load', function () { cleanGrayscaleFrame(frame); });
    }
  }

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(findAndCleanPrintFrame);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
  findAndCleanPrintFrame();
})();